// Mock data for Aruna's Advanced Dental Clinic

export const clinicInfo = {
  name: "ARUNA'S ADVANCED DENTAL CLINIC",
  tagline: "Your Smile, Our Priority",
  description: "Experience world-class dental care with cutting-edge technology and compassionate service. We're committed to making your smile brighter and healthier.",
  doctor: {
    name: "J UDAY KUMAR",
    qualification: "BDS, MDS",
    specialization: "Endodontist",
    experience: "15 years"
  },
  address: "Plot No 3, Janga Reddy Complex, Balapur X Roads, Triveni Nagar Colony Phase 4, Opposite to Indian Oil Petrol Pump, Opposite to Amrutha Medicare, Hyderabad - 500005",
  phone: "+91 8142221443",
  alternatePhone: "+91 9121280645",
  email: "arunasadvanceddentalcare@gmail.com",
  whatsapp: "+918142221443",
  pincode: "500005",
  hours: {
    weekdays: "10:00 AM - 2:00 PM & 5:30 PM - 8:45 PM",
    saturday: "10:00 AM - 2:00 PM & 5:30 PM - 8:45 PM",
    sunday: "10:30 AM - 1:30 PM"
  },
  socialMedia: {
    facebook: "https://facebook.com",
    instagram: "https://instagram.com",
    twitter: "https://twitter.com"
  }
};

export const services = [
  {
    id: 1,
    title: "Aligners",
    description: "Clear, invisible aligners for discreet teeth straightening. Achieve a perfect smile without traditional braces.",
    icon: "Grid3x3",
    features: ["Invisible Treatment", "Removable Aligners", "Custom Fitted", "Faster Results"]
  },
  {
    id: 2,
    title: "Dental Implants",
    description: "Permanent solution for missing teeth with state-of-the-art implant technology and expert care.",
    icon: "Anchor",
    features: ["Single Implants", "Multiple Implants", "Full Arch Restoration", "Bone Grafting"]
  },
  {
    id: 3,
    title: "Laser Root Canals",
    description: "Advanced pain-free laser root canal treatment using cutting-edge technology for faster healing.",
    icon: "Zap",
    features: ["Pain-Free Treatment", "Laser Technology", "Faster Recovery", "Single Visit"]
  },
  {
    id: 4,
    title: "CAD/CAM Crowns",
    description: "Same-day digital crowns designed and crafted using advanced CAD/CAM technology.",
    icon: "Cpu",
    features: ["Same Day Crowns", "Digital Design", "Perfect Fit", "Natural Looking"]
  },
  {
    id: 5,
    title: "Teeth Bleaching",
    description: "Professional teeth whitening for a brighter, more confident smile in just one session.",
    icon: "Sparkles",
    features: ["In-Office Whitening", "Instant Results", "Safe & Effective", "Long Lasting"]
  },
  {
    id: 6,
    title: "Veneers",
    description: "Transform your smile with custom porcelain veneers for a flawless, celebrity-like appearance.",
    icon: "Smile",
    features: ["Porcelain Veneers", "Stain Resistant", "Natural Look", "Long Lasting"]
  },
  {
    id: 7,
    title: "Laminates",
    description: "Ultra-thin ceramic laminates for a minimally invasive smile makeover with stunning results.",
    icon: "Layers",
    features: ["Minimal Tooth Prep", "Ultra-Thin Design", "Durable Material", "Beautiful Finish"]
  },
  {
    id: 8,
    title: "Scaling & Polishing",
    description: "Professional deep cleaning to remove plaque, tartar, and stains for healthier gums and teeth.",
    icon: "Sparkle",
    features: ["Deep Cleaning", "Plaque Removal", "Gum Health", "Stain Removal"]
  },
  {
    id: 9,
    title: "Wisdom Tooth Surgeries",
    description: "Expert surgical removal of wisdom teeth with minimal discomfort and quick recovery.",
    icon: "Cross",
    features: ["Pain-Free Extraction", "Expert Surgeons", "Fast Recovery", "Sedation Options"]
  },
  {
    id: 10,
    title: "Full Mouth Rehabilitation",
    description: "Comprehensive restoration of your entire mouth for optimal function, health, and aesthetics.",
    icon: "Activity",
    features: ["Complete Restoration", "Custom Treatment Plan", "Multiple Procedures", "Smile Makeover"]
  },
  {
    id: 11,
    title: "Dentures",
    description: "High-quality, natural-looking dentures to restore your smile and chewing function.",
    icon: "Circle",
    features: ["Full Dentures", "Partial Dentures", "Custom Fit", "Natural Appearance"]
  },
  {
    id: 12,
    title: "Pain Free Dentistry",
    description: "Experience anxiety-free dental care with advanced sedation and gentle techniques.",
    icon: "Heart",
    features: ["Sedation Options", "Gentle Techniques", "Anxiety-Free", "Comfortable Care"]
  },
  {
    id: 13,
    title: "Composites",
    description: "Tooth-colored composite fillings for natural-looking cavity repairs and aesthetic enhancements.",
    icon: "Droplet",
    features: ["Tooth-Colored", "Mercury-Free", "Strong & Durable", "Aesthetic Results"]
  },
  {
    id: 14,
    title: "Braces",
    description: "Traditional and modern braces for effective teeth straightening and bite correction.",
    icon: "Grid2x2",
    features: ["Metal Braces", "Ceramic Braces", "Effective Alignment", "Affordable Option"]
  },
  {
    id: 15,
    title: "Self Ligating Braces",
    description: "Advanced self-ligating braces for faster treatment with fewer adjustments and more comfort.",
    icon: "Move",
    features: ["Faster Treatment", "Fewer Visits", "More Comfortable", "Better Hygiene"]
  }
];

export const testimonials = [
  {
    id: 1,
    name: "Rajesh Kumar",
    rating: 5,
    text: "Best dental clinic in Balapur! Dr. Uday Kumar is extremely professional and the laser root canal treatment was completely painless. Highly recommend to everyone.",
    location: "Balapur"
  },
  {
    id: 2,
    name: "Priya Sharma",
    rating: 5,
    text: "Got my teeth alignment done with clear aligners here. The results are amazing! Staff is very friendly and the clinic is very clean and modern.",
    location: "Triveni Nagar"
  },
  {
    id: 3,
    name: "Mohammed Farhan",
    rating: 5,
    text: "Excellent service! The dental implants procedure was smooth and the doctor explained everything clearly. Very satisfied with the treatment and results.",
    location: "Badangpet"
  },
  {
    id: 4,
    name: "Anitha Reddy",
    rating: 5,
    text: "My daughter had a fear of dentists but Dr. Uday Kumar made her so comfortable. The pediatric care here is exceptional. Thank you so much!",
    location: "Kanchanbagh"
  },
  {
    id: 5,
    name: "Venkat Rao",
    rating: 5,
    text: "Got my CAD/CAM crown done in just one visit! The technology here is really advanced. No more multiple appointments. Great experience overall.",
    location: "Nadergul"
  },
  {
    id: 6,
    name: "Swathi Menon",
    rating: 5,
    text: "Teeth whitening treatment gave me the confidence I needed. The results are natural-looking and long-lasting. Dr. Uday is an expert in cosmetic dentistry!",
    location: "Adibatla"
  },
  {
    id: 7,
    name: "Anil Kumar",
    rating: 5,
    text: "Had my wisdom tooth extracted here. It was completely pain-free! The clinic is very hygienic and follows all safety protocols. Highly professional team.",
    location: "Mallapur"
  },
  {
    id: 8,
    name: "Kavitha Devi",
    rating: 5,
    text: "Been coming here for regular checkups for 2 years now. The scaling and polishing service is excellent. My gums are much healthier now. Thank you!",
    location: "Tukkuguda"
  },
  {
    id: 9,
    name: "Srinivas Reddy",
    rating: 5,
    text: "Got my full mouth rehabilitation done here. Dr. Uday Kumar and his team are simply the best! My smile has completely transformed. Worth every penny!",
    location: "Barkas"
  },
  {
    id: 10,
    name: "Neha Patel",
    rating: 5,
    text: "The veneers look so natural! I can't stop smiling now. The attention to detail and the care taken during the procedure was remarkable. Excellent work!",
    location: "Dhatu Nagar"
  },
  {
    id: 11,
    name: "Ramesh Babu",
    rating: 5,
    text: "Self-ligating braces here are the best! Treatment time is shorter and much more comfortable than traditional braces. Very happy with the progress.",
    location: "Mithila Nagar"
  },
  {
    id: 12,
    name: "Lakshmi Devi",
    rating: 5,
    text: "Dental implants changed my life! Can eat properly now and smile confidently. Dr. Uday Kumar is very skilled and caring. Thank you so much!",
    location: "Kanchanbagh"
  },
  {
    id: 13,
    name: "Suresh Kumar",
    rating: 5,
    text: "Wonderful experience! The composite fillings are so natural that no one can tell. Dr. Uday Kumar's attention to detail is impressive. Highly recommend!",
    location: "Gayatri Nagar"
  },
  {
    id: 14,
    name: "Divya Rani",
    rating: 5,
    text: "Best dental clinic near MIDHANI area! The laminates procedure was flawless. My teeth look amazing now. Thank you Dr. Uday Kumar!",
    location: "Midhani"
  },
  {
    id: 15,
    name: "Karthik Reddy",
    rating: 5,
    text: "Got my braces here and the treatment has been excellent. The staff is very professional and the clinic is conveniently located. Very satisfied!",
    location: "Karmanghat"
  },
  {
    id: 16,
    name: "Manjula Devi",
    rating: 5,
    text: "Pain-free dentistry at its best! Had multiple procedures done and never felt any discomfort. Dr. Uday Kumar is truly an expert. Great clinic!",
    location: "Sai Nagar"
  },
  {
    id: 17,
    name: "Ravi Teja",
    rating: 5,
    text: "The dentures fit perfectly and look completely natural. Very happy with the service and the care provided. Excellent work by the team!",
    location: "New Balaji Nagar"
  },
  {
    id: 18,
    name: "Saritha Reddy",
    rating: 5,
    text: "Came here for teeth bleaching and the results exceeded my expectations! My teeth are several shades whiter. Very professional service!",
    location: "Prashanti Nagar"
  },
  {
    id: 19,
    name: "Naresh Kumar",
    rating: 5,
    text: "Emergency dental care was handled promptly and professionally. Dr. Uday Kumar fixed my broken tooth immediately. Grateful for the excellent service!",
    location: "Jillelaguda"
  },
  {
    id: 20,
    name: "Padma Rani",
    rating: 5,
    text: "Been going to this clinic for years. The preventive care and regular checkups have kept my teeth in perfect condition. Best dentist in the area!",
    location: "Almasguda"
  },
  {
    id: 21,
    name: "Shankar Prasad",
    rating: 5,
    text: "My wife and I both got our dental work done here. From cleaning to crowns, everything was handled with utmost care. Highly recommend this clinic!",
    location: "Meerpet"
  },
  {
    id: 22,
    name: "Geeta Sharma",
    rating: 5,
    text: "Amazing experience with the root canal treatment. No pain at all! Dr. Uday Kumar explained every step. The clinic is very well-maintained.",
    location: "Balapur"
  },
  {
    id: 23,
    name: "Prakash Yadav",
    rating: 5,
    text: "Got my teeth whitening done and the results are fantastic! Staff is friendly and the clinic has the latest equipment. Very impressed!",
    location: "Triveni Nagar"
  },
  {
    id: 24,
    name: "Ritu Singh",
    rating: 5,
    text: "Excellent dental care! The cavity filling was quick and painless. Dr. Uday Kumar is very gentle and professional. Will definitely come back!",
    location: "Badangpet"
  },
  {
    id: 25,
    name: "Vijay Kumar",
    rating: 5,
    text: "Had my dental implant surgery here. The entire process was smooth and recovery was quick. Very happy with the outcome. Thank you!",
    location: "Nadergul"
  },
  {
    id: 26,
    name: "Sunita Devi",
    rating: 5,
    text: "My son's braces treatment is going perfectly. The progress is visible and he's very comfortable. Great clinic for kids and adults!",
    location: "Adibatla"
  },
  {
    id: 27,
    name: "Harish Reddy",
    rating: 5,
    text: "Professional and caring staff. Got my wisdom tooth removed without any complications. The aftercare instructions were very helpful!",
    location: "Karmanghat"
  },
  {
    id: 28,
    name: "Meena Kumari",
    rating: 5,
    text: "The veneers transformed my smile completely! I look 10 years younger. Dr. Uday Kumar's expertise is truly world-class!",
    location: "Mallapur"
  },
  {
    id: 29,
    name: "Ashok Kumar",
    rating: 5,
    text: "Best dental clinic in the area! Got my complete dental checkup done. Very thorough examination and excellent advice on dental hygiene.",
    location: "Tukkuguda"
  },
  {
    id: 30,
    name: "Rekha Patel",
    rating: 5,
    text: "The laser root canal was painless and quick. Amazing technology! Dr. Uday Kumar is very skilled. Highly recommend this clinic!",
    location: "Barkas"
  },
  {
    id: 31,
    name: "Deepak Singh",
    rating: 5,
    text: "Got my aligners here and the treatment plan is perfect. The staff explained everything clearly. Very satisfied with the service!",
    location: "Dhatu Nagar"
  },
  {
    id: 32,
    name: "Pooja Reddy",
    rating: 5,
    text: "Excellent cosmetic dentistry! The composite bonding looks so natural. Dr. Uday Kumar is an artist. My confidence has increased so much!",
    location: "Mithila Nagar"
  },
  {
    id: 33,
    name: "Ramesh Kumar",
    rating: 5,
    text: "The dental crown I got fits perfectly and looks amazing. Same-day service with CAD/CAM technology is brilliant. Saved so much time!",
    location: "Gayatri Nagar"
  },
  {
    id: 34,
    name: "Savita Rani",
    rating: 5,
    text: "My entire family goes to this clinic. Dr. Uday Kumar treats everyone with care. The kids love coming here. Best family dentist!",
    location: "Midhani"
  },
  {
    id: 35,
    name: "Mohan Rao",
    rating: 5,
    text: "Had severe toothache and got immediate relief. The emergency care here is excellent. Dr. Uday Kumar is always available for patients!",
    location: "Kanchanbagh"
  },
  {
    id: 36,
    name: "Anjali Sharma",
    rating: 5,
    text: "The scaling and polishing service is thorough. My teeth feel so clean! The hygienist is very gentle. Will definitely continue regular visits!",
    location: "Sai Nagar"
  },
  {
    id: 37,
    name: "Sunil Reddy",
    rating: 5,
    text: "Got my dentures replaced and the new ones are so comfortable. Eating is much easier now. Thank you Dr. Uday Kumar!",
    location: "New Balaji Nagar"
  },
  {
    id: 38,
    name: "Lata Devi",
    rating: 5,
    text: "The laminates look stunning! Everyone compliments my smile now. The procedure was quick and painless. Absolutely love it!",
    location: "Prashanti Nagar"
  },
  {
    id: 39,
    name: "Krishna Kumar",
    rating: 5,
    text: "Excellent orthodontic treatment! My self-ligating braces are much more comfortable than I expected. Great progress in just 3 months!",
    location: "Jillelaguda"
  },
  {
    id: 40,
    name: "Usha Rani",
    rating: 5,
    text: "Dr. Uday Kumar saved my tooth with expert root canal treatment. No more pain! The clinic is clean, modern, and very professional.",
    location: "Almasguda"
  }
];

export const galleryImages = [
  {
    id: 1,
    url: "https://customer-assets.emergentagent.com/job_aruna-dental-clinic/artifacts/n212zsyk_37d0fd5b-bece-4a45-9eb2-eb0664006096.jpeg",
    alt: "Aruna's Advanced Dental Clinic - Exterior view with signboard"
  },
  {
    id: 2,
    url: "https://customer-assets.emergentagent.com/job_aruna-dental-clinic/artifacts/3ap8yzvb_0814df3d-83dd-4bf5-836d-b91aeb2664d4.jpeg",
    alt: "Clinic waiting area and reception"
  },
  {
    id: 3,
    url: "https://customer-assets.emergentagent.com/job_aruna-dental-clinic/artifacts/7b7d18cu_3f18fb91-7f58-4878-be43-5df94e0ab546.jpeg",
    alt: "Reception desk and treatment area"
  },
  {
    id: 4,
    url: "https://customer-assets.emergentagent.com/job_aruna-dental-clinic/artifacts/hozznhu6_18c52dea-db6c-4ad8-a07a-1f3bede36892.jpeg",
    alt: "Modern dental treatment room"
  },
  {
    id: 5,
    url: "https://customer-assets.emergentagent.com/job_aruna-dental-clinic/artifacts/y5x8a6ed_04e24c65-3f07-4826-a96e-284e396f9582.jpeg",
    alt: "Advanced dental equipment and treatment chairs"
  }
];

export const whyChooseUs = [
  {
    id: 1,
    title: "Expert Team",
    description: "Highly qualified dentists with years of experience and continuous training in latest techniques.",
    icon: "Users"
  },
  {
    id: 2,
    title: "Modern Technology",
    description: "State-of-the-art equipment and advanced procedures for accurate diagnosis and treatment.",
    icon: "Cpu"
  },
  {
    id: 3,
    title: "Comfortable Environment",
    description: "Relaxing atmosphere designed to make your visit stress-free and pleasant.",
    icon: "Heart"
  },
  {
    id: 4,
    title: "Affordable Care",
    description: "Quality dental services at competitive prices with flexible payment options.",
    icon: "DollarSign"
  }
];

export const heroImage = "https://images.pexels.com/photos/4687341/pexels-photo-4687341.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940";
export const aboutImage = "https://images.unsplash.com/photo-1606811801193-e318c9a87ad7?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODF8MHwxfHNlYXJjaHwxfHxkZW50aXN0JTIwcHJvZmVzc2lvbmFsfGVufDB8fHx8MTc3NDk3Nzg0NXww&ixlib=rb-4.1.0&q=85";
